module.exports = __webpack_public_path__ + "ruby.7f34aa.svg";